export const IS_LOGGEDIN = "IS_LOGGEDIN";
export const SET_LOGGEDIN = "SET_LOGGEDIN";
